export default "__VITE_ASSET__6f1ec9af__"